import { useState, useEffect } from "react";
import { Formik, Field, Form } from "formik";
import {
    InputGroup,
    Label,
    SubmitBtn,
    SideCancelBtn,
    Wrapper,
    ScrollableContent,
    ActionSection,
    ModalHeader,
    ModalTitle,
} from "../../Styles/InputStyles";
import { MdClose } from "react-icons/md";
import tw from "tailwind-styled-components";
import * as Yup from "yup";
import "react-datepicker/dist/react-datepicker.css";
import {
    FormControl,
    Select,
    MenuItem,
    FormHelperText,
} from "@mui/material";
import DropZone from "./MediaDropZone";
import { media_types } from "../../../Config";

/* ---------------- VALIDATION ---------------- */

const mediaSchema = Yup.object().shape({
    mediaType: Yup.string()
        .required("Media type is required"),
    file: Yup.array()
        .min(1, "At least one file is required")
        .required("File is required"),
});

const PropertyMediaUploadModal = ({
    setIsMediaAdd,
    uploadMediaMutate,
    isMediaLoading,
    propId,
}) => {
    const initialMediaValues = {
        mediaType: 'Bedroom',
        file: [],
    };

    const [height, setHeight] = useState(window.innerHeight);

    useEffect(() => {
        const handleResize = () => setHeight(window.innerHeight);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const handleMediaSubmit = (values) => {
        const formData = new FormData();

        formData.append("type", values.mediaType);
        if (values.file && values.file.length > 0) {
            values.file.forEach((file) => {
                formData.append("files", file);
            });
        }
        formData.append("propId", propId);
        uploadMediaMutate(formData);
    };

    return (
        <Container style={{ height: `${height}px`, overflow: "auto" }}>
            <ModalHeader>
                <ModalTitle>Upload Media</ModalTitle>
                <button onClick={() => setIsMediaAdd(false)}>
                    <MdClose color="white" size={24} />
                </button>
            </ModalHeader>

            <div className="px-6 h-full flex flex-col justify-between">
                <Formik
                    initialValues={initialMediaValues}
                    validationSchema={mediaSchema}
                    onSubmit={handleMediaSubmit}
                >
                    {({ values, setFieldValue, errors, touched }) => (
                        <Form>
                            <ScrollableContent className="max-h-[calc(100dvh-140px)]">
                                <Wrapper>

                                    {/* MEDIA TYPE DROPDOWN */}
                                    <InputGroup>
                                        <Label>Media Type *</Label>
                                        <FormControl
                                            fullWidth
                                            error={touched.mediaType && Boolean(errors.mediaType)}
                                        >
                                            <Select
                                                value={values.mediaType}
                                                displayEmpty
                                                onChange={(e) => {
                                                    setFieldValue("mediaType", e.target.value);
                                                }}
                                                className="pl-2 h-12"
                                            >
                                                {media_types.map((type) => (
                                                    <MenuItem key={type.value} value={type.value}>
                                                        {type.label}
                                                    </MenuItem>
                                                ))}
                                            </Select>

                                            {touched.mediaType && errors.mediaType && (
                                                <FormHelperText>
                                                    {errors.mediaType}
                                                </FormHelperText>
                                            )}
                                        </FormControl>
                                    </InputGroup>

                                    {/* FILE UPLOAD */}
                                    <InputGroup>
                                        <Label>Upload Media *</Label>
                                        <FieldWrapper>
                                            <Field name="file">
                                                {(props) => (
                                                    <DropZone
                                                        fields={props.field}
                                                        setFieldValue={props.form.setFieldValue}
                                                        componentFor="expense"
                                                        File={props.field.value || []}
                                                    />
                                                )}
                                            </Field>
                                        </FieldWrapper>
                                        {errors.file && touched.file && (
                                            <ErrorMessage>{errors.file}</ErrorMessage>
                                        )}
                                    </InputGroup>

                                </Wrapper>
                            </ScrollableContent>

                            <ActionSection>
                                <SideCancelBtn
                                    type="button"
                                    onClick={() => setIsMediaAdd(false)}
                                    disabled={isMediaLoading}
                                >
                                    Cancel
                                </SideCancelBtn>
                                <SubmitBtn type="submit" disabled={isMediaLoading}>
                                    {isMediaLoading ? "Uploading..." : "Upload"}
                                </SubmitBtn>
                            </ActionSection>
                        </Form>
                    )}
                </Formik>
            </div>
        </Container>
    );
};

/* ---------------- STYLES ---------------- */

const Container = tw.div`bg-white w-full h-full min-h-[100vh] flex flex-col`;
const ErrorMessage = tw.div`text-red-500 text-xs mt-1`;
const FieldWrapper = tw.div`w-full`;

export default PropertyMediaUploadModal;